import {
   randNumber,
   randCompanyName,
   randStreetAddress,
   randStreetName,
   randCity,
   randPhoneNumber,
   randEmail,
   randZipCode,
   rand,
} from '@ngneat/falso';
import { optional } from '@library/common/functions';

import { MockCountry, Region } from './countries.mock';
import { MockContact } from './contact.mock';

import { Business } from '../base';

export class MockBusiness extends Business {
   constructor() {
      super();

      this.id = randNumber();
      this.name = randCompanyName();
      this.address1 = randStreetAddress();
      if ( optional() ) { this.address2 = randStreetName(); }
      if ( optional() ) { this.address3 = randStreetName(); }
      this.city = randCity();
      this.type = rand(['account', 'personal']);

      const country = MockCountry();
      this.country = country.code;
      if ( optional() ) { this.state = Region().code; }
      if ( optional() ) { this.postalcode = randZipCode(); }

      if ( optional() ) { this.phone = randPhoneNumber().slice( 0, 25 ); }
      if ( optional() ) { this.fax = randPhoneNumber().slice( 0, 25 ); }
      if ( optional() ) { this.email = randEmail(); }
      if ( optional() ) { this.contacts = Array.from({ length: randNumber({ max: 10 }) }, _ => new MockContact() ); }
   }
}
